/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';

var dataShows = false

// const baseUrl = 'http://192.168.0.111:48080' //本地ip王鑫
// const baseUrl = 'http://192.168.0.110:48080' //本地ip胡海兵
// const baseUrl = location.protocol+'//'+location.hostname //获取当前ip
const baseUrl = 'https://czybwg.cdutcm.edu.cn/' //线上ip

// let token = localStorage.getItem('accessToken')
console.log(document.body.offsetWidth);

// 请求超时时间
axios.defaults.timeout = 10000;

// 请求拦截器
axios.interceptors.request.use(
    config => {

        config.headers['Authorization'] = "Bearer " + localStorage.getItem('accessToken')
        return config;
    },
    error => {
        return Promise.error(error);
    })



// 响应拦截器
axios.interceptors.response.use(
    response => {
        // console.log('是200',response);
        if (response.data.code === 0) {
            return response
        } else {
            return response
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
            return new Promise(() => {
                // console.log('不是200',error);
                if (response.status === 401) {
                    // this.$router.push('/')
                    return response
                } else {
                    return response
                }
            });
        } else {
            return Promise.reject(error);
        }
    }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + url, {
            params: params
        })
            .then(res => {
                // console.log('这里跳转了？',res);
                resolve(res.data);
                if (res.data.code === 401) {
                    // console.log(3332,document.body.offsetWidth);
                    // if(document.body.offsetWidth<400){
                    //     // window.location.href = "/#/mobile/login"
                    // }else{
                    //      window.location.href = "/"
                    // }

                    // this.$router.push('/')
                    resolve(res.data);
                } else {
                    reject(res.data)
                }

            })
            .catch(err => {
                // console.log(err,'get err');
                reject(err.data)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post(url, params) {

    if (!params) {
        params = {}
    }
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + url, params)
            .then(res => {
                if (res.data.code == 0) {
                    resolve(res.data);
                } else {
                    reject(res.data)
                }
                if (res.data.code === 401) {
                    // if(document.body.offsetWidth<400){
                    //     // window.location.href = "/#/mobile/login"
                    // }else{
                    //      window.location.href = "/"
                    // }
                    resolve(res.data);
                } else {
                    reject(res.data)
                }

            })
            .catch(err => {
                console.log(err)
                reject(err.data)
            })
    });
}
/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function DELETE(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(baseUrl + url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function put(url, params) {

    if (!params) {
        params = {}
    }
    return new Promise((resolve, reject) => {
        axios.put(baseUrl + url, params)
            .then(res => {
                if (res.data.code == 0) {
                    resolve(res.data);
                } else {
                    reject(res.data)
                }

            })
            .catch(err => {
                console.log(err)
                reject(err.data)
            })
    });
}
export function upFile(url, params, header) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, header)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
